import React, { Component } from "react";
import ReactModal from "react-modal";
import * as styles from "./styles.module.css";

import { BottomSheet, Icon } from "@ebscois/react-component-library";
import { isMobile } from "react-device-detect";

class ConsentDeclineModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      consent: ""
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.content = this.content.bind(this);
  }

  onSubmit() {
    this.props.onModalSubmit();
  }

  onCancel() {
    this.props.onModalCancel();
  }

  content() {
    return (
      <div>
        <div>
          <Icon
            icon={{ glyph: "close", size: "md" }}
            className={styles.closeIcon}
            onClick={this.onCancel}
          />
        </div>
        <div className={styles.header}>
          <Icon
            icon={{ glyph: "warning", color: "orange", size: "xl" }}
            className={styles.warningIcon}
          />
          <div className={styles.headerText}>
            You chose not to grant consent. If you continue, any personal data
            we've collected will be permanently deleted and you will not create
            an account.
          </div>
        </div>
        <div className={styles.lineSeparator} />
        <div className={styles.section}>
          <strong>
            Without a personal account, you will no longer be able to:
          </strong>
          <ul className={styles.ulItem}>
            <li className={styles.liItem}>
              Access Continuing Medical Education credits and certificates
            </li>
            <li className={styles.liItem}>
              See your search history or recently viewed topics
            </li>
            <li className={styles.liItem}>
              Follow topics to receive email updates
            </li>
          </ul>
          You will still be able to anonymously access EBSCO products through
          your institution.
        </div>
        <div className={styles.formButtons}>
          <button className={styles.buttonDelete} onClick={this.onSubmit}>
            Delete My Account
          </button>
          <button className={styles.buttonCancel} onClick={this.onCancel}>
            Cancel
          </button>
        </div>
      </div>
    );
  }

  modal() {
    return (
      <ReactModal
        isOpen={this.props.isModalOpen}
        closeTimoutMs={100}
        contentLable={"GDPR account delete"}
        shouldFocusAfterRender={true}
        shouldCloseOnEsc={true}
        className={styles.modal}
      >
        {this.content()}
      </ReactModal>
    );
  }

  bottomSheet() {
    return (
      <BottomSheet
        delay={0}
        closeable={false}
        isOpen={this.props.isModalOpen}
        onClose={this.onCancel}
        transition="slide"
        speed={200}
        className={styles.bottomSheet}
      >
        {this.content()}
      </BottomSheet>
    );
  }

  render() {
    // let component;

    if (isMobile) {
      return this.bottomSheet();
    } else {
      return this.modal();
    }

    //return {component};
  }
}

ConsentDeclineModal.displayName = "ConsentDeclineModal";

ConsentDeclineModal.propTypes = {};

ConsentDeclineModal.defaultProps = {};

export default ConsentDeclineModal;
